let headerFlag = false;
let stHeader  = document.getElementById('st-Header');
let stHeaderNav  = document.getElementById('st-Header_Nav');
let stHeaderBg  = document.getElementById('st-Header_Bg');
let headerButton  = document.getElementById('st-Menu');


// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{

  history.replaceState(null, null, null);
  window.addEventListener('popstate', function() {

    $('body').addClass('preload');

    headerFlag        = false;
    stHeaderNav.classList.remove('opened');
    headerButton.classList.remove('opened');
    stHeaderBg.classList.remove('opened');
    stHeaderNav.classList.add('closed');
    headerButton.classList.add('closed');
    stHeaderBg.classList.add('closed');

    setTimeout(function(){
      $('body').removeClass('preload');
    },100);

  }, false);

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};

// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {


  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      // $('#st-Header_Navi').css({'display':'block'});
      setTimeout(function(){
        stHeaderNav.classList.remove('closed');
        headerButton.classList.remove('closed');
        stHeaderBg.classList.remove('closed');
        stHeaderNav.classList.add('opened');
        headerButton.classList.add('opened');
        stHeaderBg.classList.add('opened');
        headerFlag = true;
  		},0);
    }else{
      stHeaderNav.classList.remove('opened');
      headerButton.classList.remove('opened');
      stHeaderBg.classList.remove('opened');
      stHeaderNav.classList.add('closed');
      headerButton.classList.add('closed');
      stHeaderBg.classList.add('closed');
      headerFlag = false;
      // setTimeout(function(){
      //   // $('#st-Header_Navi').css({'display':'none'});
  		// },0);
    }
  }, false);


};



// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#sw-Youtube');
  const $content = $('#sw-Youtube_Content');

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#sw-Youtube').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},500,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    });
  });


  //close
  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function(){

    $('#sw-Youtube').css({'opacity':'1'}).stop().animate({'opacity':'0'},500,'easeOutQuart',function(){
      $('#sw-Youtube').css({'display':'none'});
      $content.children('iframe').remove();
		});
  });

};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {

  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 50;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  const __layer = $('.st-Container').attr('data-layer');
  var linkSpeed    = 1800;
  var linkAdjust   = 0;

  //トップページ時ののヘッダーリンク
  $(".header-link").on("click", function(){
    if( __layer == 'first') {
      var linkHref     = $(this).attr("href");
      var linkHash = linkHref.substr(linkHref.indexOf('#'));
      console.log(linkHash)
      var linkTarget   = $(linkHash == "#" || linkHash == "" ? 'html' : linkHash);
      var linkPosition = linkTarget.offset().top;

      if(headerFlag){
        stHeaderNav.classList.remove('opened');
        headerButton.classList.remove('opened');
        stHeaderBg.classList.remove('opened');
        stHeaderNav.classList.add('closed');
        headerButton.classList.add('closed');
        stHeaderBg.classList.add('closed');
        headerFlag = false;
      }
      $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutQuint");
      return false;
    }
  });

  //ページ内リンク
  $("a[href^='#']").on("click", function(){

    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkPosition = linkTarget.offset().top;

    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutQuint");
    return false;
  });

  // if( __layer == 'first') {
  //   console.log('aaa');
  // }



};


// ------------------------------------------------------------------------
// commentModal
// ----- BOTH
// ------------------------------------------------------------------------
const commentModal = () => {
  const $modal = $('#sw-Comment');

  $('.js-comment').on('click', function(){

    var target = $(this).data('modal-link');
    modalOpen(target);

    // モーダルのスクロール位置上に
    scrollComment();

  });

  $('.sw-Comment_Close').on('click', function(){

    modalClose();

  });

  // モーダルを開く
  function modalOpen(target) {

    // モーダルが開いたら、bodyにfixedを付与
    // bodyFixedOn();

    $('[data-modal-content = ' + target + ']').addClass('is-show');
    $modal.addClass('opened');

  }

  // モーダルを閉じる
  function modalClose() {
    $('[data-modal-content]').removeClass('is-show');
    $modal.removeClass('opened');

    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
    // bodyFixedOff();

  }

  //モーダルのスクロール一番上へ
  function scrollComment() {

    $('#sw-Comment,#sw-Comment_Inner').scrollTop(0);

  }

};

// ------------------------------------------------------------------------
// kvModal
// ----- BOTH
// ------------------------------------------------------------------------
const kvModal = () => {
  const $modal = $('#modal-KV');

  $('.btn_KV').on('click', function(){

    var target = $(this).data('kv-link');
    modalOpen(target);

    // console.log(target);

    // モーダルのスクロール位置上に
    scrollComment();

  });

  $('.modal-KV_Close').on('click', function(){

    modalClose();

  });

  // モーダルを開く
  function modalOpen(target) {

    // モーダルが開いたら、bodyにfixedを付与
    // bodyFixedOn();

    $('[data-kv-content = ' + target + ']').addClass('is-show');
    $modal.addClass('opened');

  }

  // モーダルを閉じる
  function modalClose() {
    $('[data-kv-content]').removeClass('is-show');
    $modal.removeClass('opened');

    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
    // bodyFixedOff();

  }

  //モーダルのスクロール一番上へ
  function scrollComment() {

    $('#modal-KV,#modal-KV_Inner').scrollTop(0);

  }

};


// ------------------------------------------------------------------------
// divideCharacter
// ----- BOTH
// ------------------------------------------------------------------------
const divideCharacter = () => {

  const textbox = document.querySelectorAll('.divide-character');
  const textboxArray = Array.prototype.slice.call(textbox); //Array


  textboxArray.forEach(textbox => {
    let text = textbox.textContent;
    textbox.innerHTML = null;

    text.split('').forEach(function (c) {
      textbox.innerHTML += '<span class="letter">'+c+'</span>';
    });
  });
};

// ------------------------------------------------------------------------
// showPopup
// ----- BOTH
// ------------------------------------------------------------------------
const showPopup = () => {
  // open
  $('#popup-Image').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},500,'easeOutQuart',function(){
    return false;
  });

  //close
  $('#popup-Bg,#popup-Close').on('click', function(){
    $('#popup-Image').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#popup-Image').css({'display':'none'});
		});
  });

};

// ------------------------------------------------------------------------
// closeFloatingbanner
// ----- BOTH
// ------------------------------------------------------------------------
const closeFloatingbanner = () => {
  //close
  $(document).ready(function () {
    $('.banner-close').click(function() {
        $('.banner').parent().hide();
    });
  });
  $(window).on('scroll', function() {
      if ($(this).scrollTop() > 100) {
          $('#floating-banner').fadeIn(300);
      }
  });
};




export {
  preload,
  toggleHeader,
  showMovie,
  anchorLink,
  commentModal,
  kvModal,
  divideCharacter,
  showPopup,
  closeFloatingbanner,
}



// WEBPACK FOOTER //
// ./src/watakon_v0/assets/js/include/module.js